// eslint-disable-next-line import/prefer-default-export
export const swimlaneColumnStyles = theme => ({
  '&:first-child': {
    paddingLeft: 0,
  },
  '&:last-child': {
    paddingRight: 0,
  },
  display: 'flex',
  flexShrink: 0,
  height: 'auto',
  padding: theme.spacing(0, 1),
  scrollSnapAlign: 'center',
  scrollSnapStop: 'always',
  width: 336,
  [theme.breakpoints.between('900', '1024')]: {
    '&:first-child': {
      paddingLeft: 0,
    },
    '&:last-child': {
      paddingRight: theme.spacing(3),
    },
    padding: theme.spacing(0, 0.5),
  },
  [theme.breakpoints.between('800', '900')]: {
    '&:first-child': {
      paddingLeft: 0,
    },
    '&:last-child': {
      paddingRight: theme.spacing(3),
    },
    padding: theme.spacing(0, 0.5),
  },
  [theme.breakpoints.down('770')]: {
    '&:first-child': {
      paddingLeft: theme.spacing(2),
    },
    '&:last-child': {
      paddingRight: theme.spacing(2),
    },
    padding: theme.spacing(0, 0.5),
  },
});
